export const TEST_ID = 'editMapButton';
